// extracted by mini-css-extract-plugin
export var textInput = "_cv-0";